/*
*	Polydraw.js
*	Polygon Drawing Plugin.
*
*	Dependencies: jQuery, Google Maps V3 Api, Google Maps Drawing Library.
*/

/*
	How to use polyDraw-1.2.

	Tips:
	The shape ID refers to the index of the shape in the polyDraw.options.myZones[] array.

	Functions:

	// ------Initial------
	polyDraw.create(map object{}, user options{});
	Pass in the map object and then overwrite whatever options you want. Options are located at the END of this file.

	polydraw.destruct(reason (string, optional));
	... doesn't actually work yet.

	// ------Drawing------
	polyDraw.drawingModeOn( shape id(int, shouldn't use), shape options({}) ); [EDIT]
	Pass in -1 as standard, because that's the default polygon drawing space. Opts isn't used, but should probably change the polgon colours, etc.

	drawModeFreehand(); drawModePolygon(); drawModeRectangle(); drawModeCircle();
	All of these are fired by the controls that are loaded in, but if you want you could call them instead on other buttons.

	polyDraw.drawingModeOff();
	Calls FinishDrawing() which turns off the buttons and destroys the drawing library.

	polyDraw.drawRectangle(coords [{google.maps.latLng}], shape id (int), map object{}, options {});
	polydraw.drawPolygon(coords [{google.maps.latLng}], shape id (int), map object{}, options {});
	Just draws a shape on the map if you pass in the coordinates. Best to pass the map in, but will retrieve it from options if false. Will take {option:changes} for polygon.

	// ------Editing------

	polyDraw.retrievePolygon(shape id(int));
	If the polygon with that id exists, and is an object{} which a polygon should be, in the myZones[] array then it will return it.

	polyDraw.polygonEditingToggle(true or false(boolean), shape id (int));
	Literally just changes all the polygons options to {clickable:false} and takes a backup of the one you pass the ID in for.

	polyDraw.polygonEditingUndo(shape id (int));
	If you've backed up a shape using polygonEditingToggle, this will restore it to it's pre-edited coordinates.

	polyDraw.updatePolyOptions(shape id(int), shape options{});
	Use this to change the shape options, like {fillOpacity: 0.2} or {fillColor: #FFFFFF} or whatever.

	polyDraw.updatePolyShape(coords[{google.maps.latLng}], shape id(int), shape options{});	[EDIT]
	This will update the shape ID polygons shape, but the shape options aren't currently linked to anything.

	polyDraw.removeSpecificPolygon(id)
	Fairly straight forward, deletes the polygon from the myZones[] array and removes if from the map.

	polyDraw.removeAllPolygons();
	Removes all polygons from the map and deletes them all from memory.

	// ------Utilities------

	polyDraw.getMap;
	Returns the loaded map object{}.

	polyDraw.options;
	Returns the loaded options{} for the plugin.


	// ------Callbacks------
	Set your own function(){} for each of the callbacks, the default is usually console.log(something);
	If you don't want them to fire, then pass function(){return;}

	polyClickEvent		      	: Fires when you click on the polygon.
	polydblClickEvent	      	: Fires when you dblclick on the polygon. Doesn't do anything about map zooming though.
	polyStartDrawingEvent     	: Fires when you start drawing.
	polyFinishDrawingEvent    	: Fires when you have finished drawing. ( Probably use polyDraw.drawingModeOff(); ).
	controlsSavecallback      	: Fires when you press 'Save' on the menu.
	controlsCancelCallback    	: Fires when you press 'Cancel' on the menu.
*/

var polyDrawInstance;															// Holds itself - only 1 polyDrawInstance allowed.

var polyDraw = (function(){													// ------"Globals"------

	var activeMapListeners = [];												// Holds the active map listeners. Removes them when done drawing.
	var activePolyListeners = [];												// Unused as of now.
	var drawLib = null;														// Google Maps Drawing Library.
	var mouseDown = 0;														// Selfex. Used for timing event listeners.
	var differentiate_click = 0;											// Selfex. Used for distinguishing sgl/dbl click.
	var selectedPolygon = -1;												// What polygon is selected.
	var listenersadded = 0;													// Yes/No. Used to prevent dup listeners.


	$( document ).ready(function(){											// ------Controls functionality------
		// polydraw_plugin = polyDraw.fetch();

		$("#polydraw_controls").on("click", "#polydraw_draw", function(){ 						// Freedraw
			if(polyDrawInstance.options.zoneCreatingEnabled == false) polyDrawInstance.drawModeFreehand();
			return;
		});

		$("#polydraw_controls").on("click", "#polydraw_polygon", function(){ 					// Point to point
			if(polyDrawInstance.options.zoneCreatingEnabled == false) polyDrawInstance.drawModePolygon(false);
			return;
		});

		$("#polydraw_controls").on("click", "#polydraw_rectangle", function(){				 	// Rectangle
			if(polyDrawInstance.options.zoneCreatingEnabled == false) polyDrawInstance.drawModeRectangle(false);
			return;
		});

		$("#polydraw_controls").on("click", "#polydraw_polyline", function(){				 	// PolyLine
			if(polyDrawInstance.options.zoneCreatingEnabled == false) polyDrawInstance.drawModePolyline(false);
			return;
		});

		$("#polydraw_controls").on("click", "#polydraw_cancel", function(){ 					// Cancel - calls a specified function.
			polyDrawInstance.options.controlsCancelCallback(false, false);
		});

		$("#polydraw_controls").on("click", "#polydraw_save", function(){ 						// Again, calls a specified function.
			polyDrawInstance.controlsSaveCallback(false, false);
		});

	});
										//------Initialisation------
	function init(map_obj, user_options){
		if(typeof(map_obj) == "undefined") return destroy_me("No Map.");

		var controls = {													// The control elements
			draw			:	'<div class="polydraw_control"><a class="polydraw_control_link" id="polydraw_draw">		<img src="'+_getOptions().imageDirectory+'draw.png" 	alt="Freehand Polygon" />Draw</a></div>',
			draw_polygon	:	'<div class="polydraw_control"><a class="polydraw_control_link" id="polydraw_polygon">	<img src="'+_getOptions().imageDirectory+'draw.png" 	alt="Draw Polygon" />Point</a></div>',
			draw_rectangle	:	'<div class="polydraw_control"><a class="polydraw_control_link" id="polydraw_rectangle"><img src="'+_getOptions().imageDirectory+'draw.png" 	alt="Draw Rectangle" />Rectangle</a></div>',
			draw_polyline	:	'<div class="polydraw_control"><a class="polydraw_control_link" id="polydraw_polyline"><img src="'+_getOptions().imageDirectory+'draw.png" 	alt="Draw Line" />Line</a></div>',
			edit			:	'<div class="polydraw_control" style="display:none;"><a class="polydraw_control_link" id="polydraw_edit">		<img src="'+_getOptions().imageDirectory+'edit.png" 	alt="Edit" />Edit</a></div>',
			save			:	'<div class="polydraw_control"><a class="polydraw_control_link" id="polydraw_save">		<img src="'+_getOptions().imageDirectory+'save.png" 	alt="Save" />Save</a></div>',
			cancel			:	'<div class="polydraw_control"><a class="polydraw_control_link" id="polydraw_cancel">	<img src="'+_getOptions().imageDirectory+'cancel.png" 	alt="Cancel" />Cancel</a></div>'
		}

		$controls = '';
		for (control in controls){
			if(_getOptions().controlsEnabled[control] == true)				// Checks the config before placing.
				$controls = $controls+controls[control];
		}
		$("#"+_getOptions().controlsElementId).html($controls);				// Places the controls

		map_obj.data.addListener('click', function(evt) {
			var feature = evt.feature;
			var id = feature.getId();
			var doit = 0;

			feature.setProperty("active", 1);
			bb_get(site_url+"ajax/get_polygon_info/", {
				"id"	: id,
				"lat"	: evt.latLng.lat(),
				"lng"	: evt.latLng.lng()
			}, displayPolygon);
			toolpane_show("polygontools");
		});

									// ------Private Functions / Vars------
									//------ Main Functions (directly called)------

		function createRectangleZoneFromCoords(coords, id, map_obj, opts){	// Must have coords and ID.
			map_obj = map_obj || _getOptions().map_obj;						// Map or map passed in, either's good.
			defaults = {
				id				: id,
				bounds			: coords,
				strokeColor		: "#FF0000",
				strokeOpacity	: 0.5,
				// strokeWeight	: 2,
				fillOpacity		: 0.2,
				fillColor		: "#FF0000",
				editable		: false,		/* _getOptions().zoneEditingEnabled, */
				draggable		: false,
				clickable		: true,			/*, _getOptions().zoneEditingEnabled, */
				// geodesic		: true
				converted		: false
			}

			user_opts = $.extend({}, defaults, opts);
			var newZoneRectangle = new google.maps.Rectangle(user_opts);
			goListenforClicks(newZoneRectangle, _getOptions().polyClickEvent, _getOptions().polyDblClickEvent);
			newZoneRectangle.type = _getOptions().polyRectangleCode;
			newZoneRectangle.isDragging = false;
			newZoneRectangle.isEditing = true;
			newZoneRectangle.isMouseover = false;
			newZoneRectangle.setMap(_getOptions().map_obj);
			_getOptions().myZones[id] = newZoneRectangle;			// Add to myZones array (all zones be there).
		}

		function createPolyLineZoneFromCoords(coords, id, map_obj, opts){	// Must have coords and ID.
			map_obj = map_obj || _getOptions().map_obj;						// Map or map passed in, either's good.
			defaults = {
				id				: id,
				path			: coords,
				color			: "#FF0000",
				strokeColor		: "#FF0000",
				strokeOpacity	: 0.5,
				strokeWeight	: 4,
				// geodesic		: true,
				editable		: false,		/* _getOptions().zoneEditingEnabled, */
				draggable		: false,
				clickable		: true,			/* _getOptions().zoneEditingEnabled */
				converted		: false
			}

			user_opts = $.extend({}, defaults, opts);	// Merge the opts passed in with defaults, overwriting.
			var newZonePolyline = new google.maps.Polyline(user_opts);
			goListenforClicks(newZonePolyline, _getOptions().polyClickEvent, _getOptions().polyDblClickEvent); // Hit listeners.
			newZonePolyline.type = _getOptions().polyPolylineCode;
			newZonePolyline.isDragging = false;
			newZonePolyline.isEditing = false;
			newZonePolyline.isMouseover = false;
			newZonePolyline.setMap(_getOptions().map_obj);
			if(typeof(_getOptions().myZones[id]) === "object"){ _getOptions().myZones[id].setMap(null); delete(_getOptions().myZones[id])}
			_getOptions().myZones[id] = newZonePolyline;			// Add to myZones array (all zones be there).
			return id;
		}

		function createPolygonZoneFromCoords(coords, id, map_obj, opts){	// Must have coords and ID.
			map_obj = map_obj || _getOptions().map_obj;						// Map or map passed in, either's good.

			defaults = {
				id				: id,
				path			: coords,
				strokeColor		: "#FF0000",
				strokeOpacity	: 0.5,
				// strokeWeight	: 2,
				// geodesic		: true,
				fillOpacity		: 0.2,
				fillColor		: "#FF0000",
				editable		: false,		/* _getOptions().zoneEditingEnabled, */
				draggable		: false,
				clickable		: true,			/* _getOptions().zoneEditingEnabled */
				converted		: false
			}
			user_opts = $.extend({}, defaults, opts);	// Merge the opts passed in with defaults, overwriting.

			if(typeof(user_opts['geo_type']) !== 'undefined'){
				if(user_opts['geo_type'] == "MULTIPOLYGON"){
					function reverse_multi_array(that){
						for(var x in that){
							that[x].reverse();
						}
					}

					$.map(coords, reverse_multi_array);
					// coords.map(reverse_multi_array);

					var geoJSON = {
						"type" : "Feature",
						"id"	: id,
						"geometry" : {
							"type" : "MultiPolygon",
							"coordinates": [coords]
						}
					};

					// get the current style
					// var current_style = map_obj.data.getStyle();
					// console.log(current_style);
					// map_obj.data.setStyle(user_opts);
					// console.log(user_opts);

					var feature = map_obj.data.addGeoJson(geoJSON);
					map_obj.data.overrideStyle(feature[0], user_opts);

					_getOptions().myDataZones[id] = feature;
					_getOptions().myDataStyles[id] = user_opts;

					return id;
					// }
				}
			}
			var newZonePolygon = new google.maps.Polygon(user_opts);
			// var newZonePolygon = new google.maps.Data.Polygon([coords]);
			goListenforClicks(newZonePolygon, _getOptions().polyClickEvent, _getOptions().polyDblClickEvent); // Hit listeners.
			newZonePolygon.type = _getOptions().polyPolygonCode;
			newZonePolygon.isDragging = false;
			newZonePolygon.isEditing = false;
			newZonePolygon.isMouseover = false;
			newZonePolygon.setMap(_getOptions().map_obj);
			if(typeof(_getOptions().myZones[id]) === "object"){ _getOptions().myZones[id].setMap(null); delete(_getOptions().myZones[id])}
			_getOptions().myZones[id] = newZonePolygon;			// Add to myZones array (all zones be there).
			return id;
		}

        function convertPolygonZoneFromRectangle(id, opts)
        {
            var existing = _getOptions().myZones[id];

            if (typeof existing != 'object') {
                return false;
            }

            if (!confirm('Are you sure you wish to convert this zone into a polygon?')) {
                return false;
            }

            var coords = existing.getBounds();
            var new_coords = [
                new google.maps.LatLng(coords.getNorthEast().lat(),coords.getSouthWest().lng()),
                coords.getNorthEast(),
                new google.maps.LatLng(coords.getSouthWest().lat(),coords.getNorthEast().lng()),
                coords.getSouthWest()
            ];

            _getOptions().myZones[id].setMap(null);
            _getOptions().myZones[id].converted = true;

            var defaults = {
                "fillColor": "#00FF00",
                "fillOpacity": 0.2,
                "strokeColor": "#00FF00",
                "strokeOpacity": 0.5,
                "editable": true
            };

            // Merge the opts passed in with defaults, overwriting.
            user_opts = $.extend({}, defaults, opts);
            createPolygonZoneFromCoords(new_coords, -1, _getOptions().map_obj, user_opts);

            return id;
        }

		function updatePolygonOptions(id, opts){								// Overwrites polygon.whatever in opts.
			polyShape = _getOptions().myZones[id];								// Keeps values not in opts.
			if(typeof(polyShape) !== 'object') return false;
			polyShape.setOptions(opts);
			return polyShape;
		}

		function updatePolygonShape(coords, id, opts){							// [UNUSED]
			polyShape = _getOptions().myZones[id];								// ToDo:: Maybe split into 2 functions?
			if(typeof(polyShape) !== 'object') return false;
			switch(polyShape.type){
				case "rectangle" :
					polyShape.setBounds(coords);
					break;
				case "polygon":
				default:
					polyShape.setPath(coords);
					break;
			}
			return polyShape;
		}

		function retrievePolygon(id){											// Returns the polygon shape.
			polyshape = _getOptions().myZones[id];
			if(typeof(polyshape) !== 'object') return false;
			return polyshape;
		}

		function removeSpecificPolygon(id){
			if(typeof(_getOptions().myZones[id]) == "object"){
				_getOptions().myZones[id].setMap(null);
				delete(_getOptions().myZones[id]);
			} else {
				return false;
			}
			return true;
		}

		function removeAllPolygons(){
			for (var p in _getOptions().myZones){
				_getOptions().myZones[p].setMap(null);
				delete(_getOptions().myZones[p]);
			}
			_getOptions().myZones = [];
			_getOptions().newZoneLines = [];
			_getOptions().myZonesBackup = [];
			_getOptions().myZonesBackupPosition = 0;
			removeAllMultiPolygons();

		}

		function removeAllMultiPolygons(){
			_getOptions().map_obj.data.forEach(function(_feature){
				_getOptions().map_obj.data.remove(_feature);
			});
		}

		function drawingMode(id, opts){											// Turns on the drawing, enables the library.
			_getOptions().polyStartDrawingEvent();								// Fires the starting to draw event.
			var polygon = _getOptions().myZones[id];
			if(id == false || id == '' || id == -1 ){
				id = -1;															// New polys go in -1
				_getOptions().isCreatingNewZone = true;
			} else {
				return;													// ?? ToDo:: Figure out what to do if anything if you pass in an ID. Maybe remove.
			}
			// $("#polydraw_controls").show();										// Show the polydraw controls...
			$("#"+_getOptions().controlsElementID).show();										// Show the polydraw controls...
			drawLib = new google.maps.drawing.DrawingManager({
				drawingControl			: false,								// ... but not the google maps drawing lib ones.
				drawingControlOptions	: {	"drawingModes"	: [	google.maps.drawing.OverlayType.RECTANGLE,
																google.maps.drawing.OverlayType.POLYGON,
																google.maps.drawing.OverlayType.POLYLINE]},
				map						: _getOptions().map_obj,
				draggable				: false,								// Default opts...
				polygonOptions			: {	"fillColor"		: "#00FF00",		// ToDo:: use OPTS var to maybe change this?
											"fillOpacity"	: 0.2,
											"strokeColor"	: "#00FF00",
											"strokeOpacity"	: 0.5 },
				rectangleOptions		: {	"fillColor"		: "#00FF00",
											"fillOpacity"	: 0.2,
											"strokeColor"	: "#00FF00",
											"strokeOpacity"	: 0.5 },
				polylineOptions			: { "fillColor"		: "#00FF00",
											"fillOpacity"	: 0.2,
											"strokeColor"	: "#00FF00",
											"strokeOpacity"	: 0.5 }
			});
		}

		function freeDraw(){														// Draws freehand
			_getOptions().map_obj.setOptions({draggableCursor: 'crosshair'});
			_getOptions().zoneCreatingEnabled = true;
			var d = google.maps.event.addListener(_getOptions().map_obj, 'mousedown', function(event){
				mouseDown = 1;
				createNewFreeZone();
			});
			activeMapListeners.push(d);

			var up = google.maps.event.addListener(_getOptions().map_obj, 'mouseup', function(event){
				mouseDown = 0;
			});
			activeMapListeners.push(up);

			var m = google.maps.event.addListener(_getOptions().map_obj, 'mousemove', function(event){
				if(mouseDown != 0){
					addCoordinateToNewZone(event.latLng);
				}
			});
			activeMapListeners.push(m);
		}

		function controlDrawPolyonNow(){
			_getOptions().zoneCreatingEnabled = true;
			drawLib.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);		// Draw a polygon.
			goListenforDrawingFinish(-1);
			return true;
		}

		function controlDrawRectangleNow(){											// Draw a rectangle.
			_getOptions().zoneCreatingEnabled = true;
			drawLib.setDrawingMode(google.maps.drawing.OverlayType.RECTANGLE);
			goListenforDrawingFinish(-1);
			return true;
		}

		function controlDrawCircleNow(){											// Draw a circle.
			_getOptions().zoneCreatingEnabled = true;
			drawLib.setDrawingMode(google.maps.drawing.OverlayType.CIRCLE);
			goListenforDrawingFinish(-1);
			return true;
		}

		function controlDrawPolyLineNow(){											// Draw a polyline.
			_getOptions().zoneCreatingEnabled = true;
			drawLib.setDrawingMode(google.maps.drawing.OverlayType.POLYLINE);
			goListenforDrawingFinish(-1);
			return true;
		}

		function finishDrawing(){													// Removes the drawing lib,
			if(drawLib !== null){													// Hides the controls.
				drawLib.setDrawingMode(null);
				drawLib.setMap(null);
			}
			// $("#polydraw_controls").hide();										// Hide the controls...
			$("#"+_getOptions().controlsElementID).hide();										// Hide the controls...
			_getOptions().zoneCreatingEnabled = false;
		}

									//------ Worker functions (not directly called)------

		function refreshMapDragging(){
			if (_getOptions().zoneCreatingEnabled) _getOptions().map_obj.setOptions({draggable: false});
			else _getOptions().map_obj.setOptions({draggable: true});
		}

		function simplifyPolygon(id, degrees){										// Simplifies the polygons shape w/less points.
			polygon = retrievePolygon(id);
			if(polygon == false || polygon.type == 'rectangle') return false;

			coords = polygon.getPath();
			new_coords = getSignificantPathCoordinates(coords, degrees);

			polygon.setPath(new_coords);
		}

		function editPolygon(id, opts){										// [UNUSED]
			defaults = {
				editable: true,
				clickable: false,
				draggable: false
			};
			user_options = $.extend({}, defaults, opts);
			updatePolygonOptions(id, user_options);
			polygonEditingToggle(true);
			_getOptions().myZoneSnapshot = _getOptions().myZones[id];
		}

		function polygonEditingToggle(bool, id){							// Makes polys unclickable and sets backup for undo.
			for(zone in _getOptions().myZones){
				_getOptions().myZones[zone].setOptions({clickable: !bool});
			}
			_getOptions().zoneEditingEnabled = bool;
			if(typeof retrievePolygon(id) === 'object'){
				switch(_getOptions().myZones[id].type){
					case "rectangle":
					_getOptions().myZoneSnapshot = _getOptions().myZones[id].getBounds();
						break;
					case "polygon":
					case "polyline":
					default:
					_getOptions().myZoneSnapshot = _getOptions().myZones[id].getPath().getArray().slice();
						break;
				}
			}
			return bool;
		}

		function polygonEditingUndo(id){
			if(typeof retrievePolygon(id) !== 'object') return;
			if(_getOptions().zoneEditingEnabled == true && id !== -1){
                _getOptions().myZones[id].setMap(_getOptions().map_obj);
				switch(_getOptions().myZones[id].type){
					case "rectangle":
						_getOptions().myZones[id].setBounds(_getOptions().myZoneSnapshot);
						break;
					case "polyline":
						// console.log(_getOptions().myZones[id]);
						// _getOptions().myZones[id].setPoints(_getOptions().myZoneSnapshot.getPath().getArray().slice());
						_getOptions().myZones[id].setPath(_getOptions().myZoneSnapshot);
						break;
					case "polygon":
					default:
						_getOptions().myZones[id].setPaths(_getOptions().myZoneSnapshot);
						break;
				}
			}
		}

		function goListenforClicks(polygon, sglFunction, dblFunction){
			if(typeof(sglFunction) != 'undefined'){
				google.maps.event.addListener(polygon, 'click', function(evt){
					differentiate_click = differentiate_click = 1 ? 0 : differentiate_click--;
					setTimeout(function(){
						if(differentiate_click == 0)
						{
							sglFunction(evt, polygon);
						}
					 }, 400);
				});
			}
			if(typeof(dblFunction) != 'undefined'){
				google.maps.event.addListener(polygon, 'dblclick', function(evt){
					differentiate_click = differentiate_click == 0 ? 2 : 0;
					dblFunction(evt, polygon);
				});
			}

			//Propagate the rightclick event to the google maps object if right click lands on polygon
			google.maps.event.addListener(polygon, 'rightclick', function(evt){
				google.maps.event.trigger(_getOptions().map_obj, 'rightclick', evt);
			});
		}

		function goListenforDrawingFinish(id){
			dl = drawLib.addListener("overlaycomplete", function(polygon){
				_getOptions().myZones[-1] = polygon.overlay;
				polygon.overlay.setMap(null);
				// console.log(polygon.type);
				switch(polygon.type){
					case "polyline":
						createPolyLineZoneFromCoords( polygon.overlay.getPath().getArray(), -1, _getOptions().map_obj, {type: _getOptions().polyPolylineCode});
						break;
					case "polygon":
					case "circle":
						createPolygonZoneFromCoords(polygon.overlay.getPath().getArray(), -1, _getOptions().map_obj, {type: _getOptions().polyPolygonCode});
						break;
					case "rectangle":
						createRectangleZoneFromCoords(polygon.overlay.getBounds(), -1, _getOptions().map_obj, {type: _getOptions().polyRectangleCode});
						break;
				}
				_getOptions().zoneCreatingEnabled = false;
				_getOptions().zoneEditingEnabled = true;
				_getOptions().polyFinishDrawingEvent(-1, _getOptions().myZones[id]);
				// finishDrawing();
			});
		}

										//------Freedraw Functions------

		function createNewFreeZone(){
			if (!_getOptions().zoneCreatingEnabled) return;
			_getOptions().newZoneLines = new google.maps.Polyline({			// Creates a new polyline with empty coordinates
				id	: -1,
				path: [],
				strokeColor: "#FF0000",
				strokeOpacity: 0.5,
				fillColour: "#FF0000",
				fillOpacity: 0.2,
				editable: false,
				draggable: false,
				clickable: false
			});

			_getOptions().newZoneLines.setMap(_getOptions().map_obj);

			// Start create new zone mode -> mousemoves will add new coordinates to this polygon
			_getOptions().isCreatingNewZone = true;
			goListenforDrawingFinish(-1);
			refreshMapDragging();
		}

		function getSignificantPathCoordinates(coordinates, degree){				// Checks the bearing between pts and removes
			tell = true;															// Superfluous points for the poly.
			if(typeof(degree) == 'undefined') {
				degree = 25;
				tell = false;
			}

			var reducedCoordinates = new Array();
			reducedCoordinates.push(coordinates.getAt(0));
			// Get circumference of this zone
			var circumference = 0;
			for (var i=1; i<coordinates.length - 1; i++){
				circumference += distanceBetweenToPoints(coordinates.getAt(i), coordinates.getAt(i+1));
			}

			// Get bearing between first and second coordinate
			var lastPushedIndex = 0;
			var sectionLength = 0;
			var lastBearing = geofunction_bearingBetweenTwoPoints(coordinates.getAt(0).lat(), coordinates.getAt(0).lng(), coordinates.getAt(1).lat(), coordinates.getAt(1).lng());

			// Check bearing for all coodinates -> if it is different from the last bearing the coordinate is pushed in the array
			for (var i=1; i<coordinates.length; i++){
				var bearing = geofunction_bearingBetweenTwoPoints(coordinates.getAt(i-1).lat(), coordinates.getAt(i-1).lng(), coordinates.getAt(i).lat(), coordinates.getAt(i).lng());
				sectionLength += distanceBetweenToPoints(coordinates.getAt(i-1), coordinates.getAt(i));

				// Get the difference between both bearings -> Math.min(...) since the bearing can be 0 or 360 degrees
				var delta_bearing = Math.abs(lastBearing - bearing);
				//if (delta_bearing > 180) delta_bearing = 360 - delta_bearing;

				// Use set of rules to find see if this coordinate is significant
				// Rule: significant if bearing > x degrees AND length of section > x (in which x is a length dependent on the complete polygon circumference)
				// All rules must be connected by OR
				// if ((delta_bearing > 80 && sectionLength > circumference / 80) || (delta_bearing > 45 && sectionLength > circumference / 30)  || (delta_bearing > 10 && sectionLength > circumference / 10))

				// This has been changed by Ben to reflect specific degrees & ignore length.

				if (/*(delta_bearing > 80 && sectionLength > circumference / 80) || (delta_bearing > 45 && sectionLength > circumference / 30)  || */(delta_bearing > parseInt(degree) /*&& sectionLength > circumference / 10*/)){
					lastBearing = bearing;
					sectionLength = 0;
					reducedCoordinates.push(coordinates.getAt(i-1));
					lastPushedIndex = i-1;
				}
			}
			reducedCoordinates.push(coordinates.getAt(coordinates.length-1));
			if(tell == true) alert("Reduced from "+ coordinates.length + " to " + reducedCoordinates.length + " points.");
			return reducedCoordinates;
		}

		function distanceBetweenToPoints(A, B)										// Calculates the real world distance between pts.
		{
			var earthRadius = 6372.795477598;
			var lat1 = A.lat() * Math.PI/180;
			var lng1 = A.lng() * Math.PI/180;
			var lat2 = B.lat() * Math.PI/180;
			var lng2 = B.lng() * Math.PI/180;
			var distance = earthRadius * Math.acos(Math.sin(lat1) * Math.sin(lat2) + Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng1 - lng2)) ;
			return distance;
		}

		function cloneArray(oldArray){
			// loop through all sub arrays and clone
			if (oldArray instanceof Array){
				var newPart = new Array();

				for ( zone in oldArray ){
					newPart.push(cloneArray(oldArray[zone]));
				}
				return newPart;
			}
			return oldArray;
		}

		function copyCoordinates(){
			var coordinatesCopy = new Array();

			for(zone in _getOptions().myZones){
				if(typeof(_getOptions().myZones[zone].getPath) != 'undefined'){
					var coords = _getOptions().myZones[zone].getPath().getArray();
				} else {
					var coords = _getOptions().myZones[zone].getBounds();
				}
				coordinatesCopy.push(cloneArray(coords));
			}
			return coordinatesCopy;
		}

		function createMapBackup(){
			// Orig: delete all following elements in the backup -> after inserting a redo for the other elements is no longer available
			// Edit: Will always be 0... probably not actually necessary anymore? // ToDo:: Check removeability.
			while (_getOptions().myZonesBackup.length > 0
				&& _getOptions().myZonesBackupPosition < _getOptions().myZonesBackup.length - 1)
			{
				_getOptions().myZonesBackup.pop();
			}

			// push new zone changes to backup -> new position in backup is at the last inserted element
			_getOptions().myZonesBackup.push(copyCoordinates());
			_getOptions().myZonesBackupPosition = _getOptions().myZonesBackup.length - 1;
		}

		function geofunction_bearingBetweenTwoPoints(lat1, lng1, lat2, lng2){			// Gets the bearing btwn 2 points.
			var a = (90 - lat1) * Math.PI / 180;
			var b = (90 - lat2) * Math.PI / 180;
			var gamma = (Math.abs(lng2 - lng1)) * Math.PI / 180;
			var c = Math.acos(Math.cos(a)*Math.cos(b) + Math.sin(a)*Math.sin(b)*Math.cos(gamma));
			if (lng1 == lng2){
				if (lat1 < lat2){
					beta = 0;
				} else {
					beta = Math.PI;
				}
			} else {
				beta  = Math.acos((Math.cos(b) - Math.cos(c)*Math.cos(a)) / (Math.sin(c)*Math.sin(a)));
			}
			if (beta != 0){
				bearing = 360 - beta / Math.PI * 180;
			} else {
				bearing = 0;
			}
			if (((lng2 - lng1) > 0) || ((lng2 == lng1) && (lat2 < lat1))){
				bearing = 360 - bearing;
			}
			bearing = Math.round(100 * bearing) / 100;
			return bearing;
		}

		function addCoordinateToNewZone(coord){
			// Execute only if the map is in create new zone mode
			if (!_getOptions().isCreatingNewZone || mouseDown == 0) return;

			if(listenersadded == 0){
				var u = google.maps.event.addListener(_getOptions().map_obj, 'mouseup', finishNewFreeZone);
				var w = window.addEventListener("mouseup", finishNewFreeZone, false);
				activeMapListeners.push(u);
				listenersadded = 1;
			}
			// Get coords, push new coord, store coords
			var coords = _getOptions().newZoneLines.getPath();
			coords.push(coord);
			_getOptions().newZoneLines.setPath(coords);
		}

		function finishNewFreeZone(evt){
			if (listenersadded == 0) return false;
			mouseDown = 0;
			// Execute only if the map is in create new zone mode
			if (!_getOptions().isCreatingNewZone) return;
			_getOptions().map_obj.setOptions({draggableCursor: 'auto'});

			var coords = _getOptions().newZoneLines.getPath(); 				// Get coords, push first coord to create
			coords.push(coords.getAt(0));									// a closed shape, store coords.
			coords = getSignificantPathCoordinates(coords);					// Simplifies the shape - less pts, better performance.
			_getOptions().newZoneLines.setPath(coords);

			// Leave create new zone mode -> mousemoves will no longer add new coordinates to this polygon
			_getOptions().isCreatingNewZone = false;

			// get coords from newZonelines and hide it from the map
			var coords = _getOptions().newZoneLines.getPath();
			createPolygonZoneFromCoords(coords, -1, _getOptions().map_obj);
			_getOptions().newZoneLines.setMap(null);

			_getOptions().polyFinishDrawingEvent(-1, _getOptions().myZones[-1]);
			_getOptions().newZoneLines.setPath([]);
			// create _getOptions().myZones coordinates backup
			createMapBackup();

			_getOptions().zoneCreatingEnabled = false;

			for(l in activeMapListeners){
				google.maps.event.removeListener(activeMapListeners[l]);
			}
			// evt.target.removeEventListener(evt.type, arguments.callee);
			window.removeEventListener('mouseup', finishNewFreeZone, false);
			listenersadded = 0;

			// finishDrawing();													// Finish drawing callback.
			refreshButtons();													// Unused, but able change btns?
			refreshMapDragging();												// Allows the map to be dragged again.
		}

											//------Utility Functions------

		function refreshButtons(){
			var controlpanel = $("#"+_getOptions().controlsElementID).find("a");
			on_class = "";
			off_class = "drawing";
			disabled_class = "dimmed";

			if(_getOptions().zoneCreatingEnabled == false){
				$("#polydraw_draw").addClass(on_class).removeClass(off_class);
			} else {
				$("#polydraw_draw").addClass(off_class).removeClass(on_class);
			}

		}

		function _getMap(){
			return map_obj;
		}

		function _getOptions(){												// Returns the Options object. Used extensively.{
			return user_options;
		}

		function _setOptions(options){										// Blanket overwrite of opts... [not used].
			user_options = options;
		}

		function destroy_me(why){
			if(typeof(why === 'string')) console.log(why);					// ToDo:: Make this happen?
			// ToDo:: Unhook listeners, remove polygons, etc.
			// ToDo:: Destroy the plugin.
			return true;
		}

											// ------Public Functions / Vars-------
		return {
			// ------Vars------
			options 		: _getOptions(),
			getMap			: _getMap(),

			// ------Functions------
				// ------Drawing-------
			drawingModeOn	: function(id, opts){							// Enables the menu,
				drawingMode(id, opts);										// Loads the drawing library.
			},

			drawModeFreehand : function(){									// Triggers FreeDraw Listeners.
				freeDraw();
			},

			drawModePolygon : function(){									// Triggers pt to pt listeners.
				controlDrawPolyonNow();
			},

			drawModeRectangle : function(){									// Triggers rectgl listeners.
				controlDrawRectangleNow();
			},

			drawModePolyline : function(){									// Triggers PolyLine listeners
				controlDrawPolyLineNow();
			},

			drawModeCircle : function(){									// Triggers Circle listeners
				controlDrawCircleNow();
			},

			drawingModeOff: function(){										// Ends the drawing mode, removes the drawing
				finishDrawing();											// library object. Will not preserve half-drawn poly.
			},

			drawRectangle : function(coords, id, map_obj, opts)				// Draws a rectgl on map. Coords = google.maps.latlng obj in []
			{																// opts = {shape:options}
				createRectangleZoneFromCoords(coords, id, map_obj, opts);
			},

			drawPolygon: function(coords, id, map_obj, opts)				// Draws a many pointed polygon on. Same opts as rtgl.
			{
				createPolygonZoneFromCoords(coords, id, map_obj, opts);
			},

			convertRectangletoPolygon: function(id, opts)
			{
			  return convertPolygonZoneFromRectangle(id, opts);
			},

			drawPolyLine: function(coords, id, map_obj, opts)				// Draws a many pointed polygon on. Same opts as rtgl.
			{
				createPolyLineZoneFromCoords(coords, id, map_obj, opts);
			},

				// ------Editing / Utility------

			retrievePolygon: function(id){									// Returns polygon obj or false.
				return retrievePolygon(id);
			},

			revertStyle: function(selected_polygon) {
				var feature = _getOptions().myDataZones[selected_polygon];

				if (typeof feature === "undefined") {
					return;
				}

				map_obj.data.revertStyle(feature[0]);
				map_obj.data.overrideStyle(feature[0], _getOptions().myDataStyles[selected_polygon]);
			},

			simplifyPolygon: function(id, degrees){							// Simplifies a POLYGON not rtgl. Removes pts based on degrees input.
				simplifyPolygon(id, degrees);
			},

			editPolygon : function(id, opts){
				editPolygon(id, opts);
			},

			updatePolyOptions: function(id, opts){							// Writes new opts to the shape, colour, etc.
				updatePolygonOptions(id, opts);
			},

			updatePolyShape: function (coords, id, opts){					// Updates the coords of a shape. //UNUSED//
				updatePolygonShape(coords, id, opts);
			},

			polygonEditingToggle : function(bool, id){						// Toggles the edit ability of a specific polygon.
				return polygonEditingToggle(bool, id);						// Makes all polys unclickable & backs up shape.
			},

			polygonEditingUndo	: function (id){							// Uses backup shape to restore poly.
				return polygonEditingUndo(id);
			},

			removeSpecificPolygon : function(id){							// Self ex. Removes the poly w/id from myZones[] and map.
				removeSpecificPolygon(id)
			},

			removeAllPolygons :  function(){								// Sets all polys map to Null then deletes.
				removeAllPolygons()
			},

			removeAllMultiPolygons :  function(){							//
				removeAllMultiPolygons()
			},

			destruct: function(why)	// String.								// ToDo:: delete the polyDrawInstance?
			{
				return destroy_me(why);										// Console.logs(why).
			}
		}
	}

	return {
		create: function(map_obj, user_options){
			var map = typeof(map_obj) == 'object' ? map_obj : null;
			defaults =
			{
				// ------Map------
				map_obj									: map,
				// ------ General Options------
				controlsElementID						: "polydraw_controls",
				imageDirectory							: "",
				controlsEnabled							: {	draw			: true,
															draw_polygon 	: true,
															draw_rectangle	: true,
															draw_polyline	: false,
															edit			: false,
															save			: false,
															cancel			: false	},
				// ------Polygon Containers, et al------
				myZones									: [],					// Main container for all polys.
				myDataZones								: {},					// Reference for Datalayer Polygons
				myDataStyles								: {},					// Reference for Datalayer Polygons
				newZoneLines							: [],					// Temp for drawing polys.
				myZoneSnapshot							: [],					// Holds a copy of poly while editing to undo if cancel.
				myZonesBackupPosition					: 0,					//
				myZonesBackup							: [],					// Holds a copy for freedraw.
				myZonesOrder							: false,				// What to order the redraw by.

				polyRectangleCode						: "rectangle", 			// This probably isn't so
				polyPolygonCode							: "polygon",			// necessary.
				polyPolylineCode						: "polyline",			// necessary.
				polyCircleCode							: "circle",				// Could move to func. where used.

				//------Event items: Facts------
				zoneCreatingEnabled						: false,				// Checks
				zoneEditingEnabled						: false,				//
				isCreatingNewZone						: false,				//

				//------User defined events------												// Examples.
				polyClickEvent							: function(event, polygon){return},		// function(evt, poly){console.log(evt,poly)},
				polydblClickEvent						: function(event, polygon){return},		// function(evt, poly){console.log(evt,poly)},
				polyStartDrawingEvent					: function(				 ){return},		// function(){console.log("Started Drawing");},
				polyFinishDrawingEvent					: function(event, polygon){return},		// function(evt, poly){console.log(evt,poly)},
				controlsSavecallback					: function(event, polygon){return},		// function(evt, poly){console.log(evt,poly)},
				controlsCancelCallback					: function(event, polygon){return}		// function(evt, poly){console.log(evt,poly)}
			}

			user_options = $.extend({}, defaults, user_options);
			options = user_options;

			if(!polyDrawInstance){														// If polyDrawInstance doesn't exist, make it.
				polyDrawInstance = init(map_obj, user_options);
			} else {

				// if(polyDrawInstance.options.myZonesOrder !== false){		// Was to order it, but doesn't work because array keys aren't mis-orderable. Object?
					// function compare_arr(a,b){
						// if(a[polyDrawInstance.options.myZonesOrder] < b[polyDrawInstance.options.myZonesOrder])
							// return -1;
						// if(a[polyDrawInstance.options.myZonesOrder] > b[polyDrawInstance.options.myZonesOrder])
							// return 1;
						// return 0;
					// }
					// polyDrawInstance.options.myZones.sort(compare_arr);
				// }
				polyDrawInstance.options.map_obj = map_obj;								// If it does, change map.
				if (polyDrawInstance.options.myZones.length > 0) {						// And then if it has polys redraw them
					for ( backup in polyDrawInstance.options.myZones){
						var polygon = $.extend({}, polyDrawInstance.options.myZones[backup]);
						polyDrawInstance.removeSpecificPolygon(backup);
						switch(polygon.type){											// Function used depends on type.
							case "rectangle":
								polyDrawInstance.drawRectangle(polygon.getBounds(), polygon.id, polyDrawInstance.options.map_obj);
								break;
							case "polyline":
								polyDrawInstance.drawPolyLine(polygon.getPath(), polygon.id, polyDrawInstance.options.map_obj);
								break;
							case "polygon":
							case "circle":
							default:
								polyDrawInstance.drawPolygon(polygon.getPath(), polygon.id, polyDrawInstance.options.map_obj);
								break;
						}
					}
				}
			}
			return polyDrawInstance;
		},
		fetch: function() {
			if (polyDrawInstance) {
				return polyDrawInstance;
			}
			return "Not initialised.";
		}
	}
})(jQuery);
